import React from "react"
import DateHelper from "../../DateHelper/DateHelper"

class RoomPopoverDataType extends React.Component {
    constructor(props) {
        super(props);
        this.onClick = this.onClick.bind(this)
    }

    render() {
        if (this.props.data) {
            return (
                <a href="#" key={this.props.data.id} onClick={this.onClick} data-toggle="popover" data-content={this.renderPopoverMenu(this.props.data, this.props.date_format)}>{this.props.data.accommodation.identifier}({this.props.data.accommodation.room_type_name})</a>
            );
        } else {
            return null;
        }
    }

    /**
    * Renders popover menu with action buttons
    */
    renderPopoverMenu(reservationSegment, dateFormat) {
        
        if (reservationSegment && reservationSegment.actions && reservationSegment.actions.length) {
            var popover = '<div class="popover-preview">';

            // close wrapper
            popover += '<div class="popover-close-wrapper"><button type="button" class="close" onclick="$(this).parents(\'.popover\').popover(\'hide\');">';
            popover += '<span aria-hidden="true">×</span><span class="sr-only">Close</span></button></div>';

            // reservation preview - heading
            popover += '<div class="popover-heading">';
            popover += '<h3><div class="model-card"><span class="ss-fluxcapacitor">&nbsp;</span></div>' + reservationSegment.accommodation.identifier + ` (#${reservationSegment.confirmation_number})` + '</h3>';
            popover += '</div>';

            // reservation details - body
            popover += '<div class="popover-body">';

            // start date
            popover += '<div class="row">'
            popover += '<div class="col-xs-6">';
            popover += '<label>' + I18n.t('arrival') + '</label>';
            popover += '<div class="value">' + DateHelper.parseDate(reservationSegment.check_in_date).toString(DateHelper.rubyToDateJS(dateFormat)) + '</div>';
            popover += '</div>';

            // end date
            popover += '<div class="col-xs-6">';
            popover += '<label>' + I18n.t('departure') + '</label>';
            popover += '<div class="value">' + DateHelper.parseDate(reservationSegment.check_out_date).toString(DateHelper.rubyToDateJS(dateFormat)) + '</div>';
            popover += '</div>';
            popover += '</div>';

            // status
            popover += '<div class="row">'
            popover += '<div class="col-xs-6">';
            popover += '<label>' + I18n.t('housekeeping_status') + '</label>';
            popover += '<div class="value">' + reservationSegment.accommodation.housekeeping_status + '</div>';
            popover += '</div>';

            // customer
            popover += '<div class="col-xs-6">';
            popover += '<label>' + I18n.t('customer') + '</label>';
            popover += '<div class="value">' + reservationSegment.customer.full_name + '</div>';
            popover += '</div>';
            popover += '</div>';

            // actions
            var actions = '';
            for (var i = 0, ilen = reservationSegment.actions.length; i < ilen; i++) {
                var action = reservationSegment.actions[i];
                actions += "<a href='" + action.path + "' class='btn btn-sm modal-iframe' data-nested='true' data-fullscreen='true'>" + I18n.t(action.name) + "</a>";
            }
            popover += '<hr style="margin:5px 0 10px 0;" />';
            popover += '<div class="quick-links">' + actions + '</div>';

            popover += '</div>'; // end popover-body
            popover += '</div>'; // end popover

            return popover;
        }
    }

    onClick(event) {
        event.stopPropagation();
    }

};

export default RoomPopoverDataType